/// <amd-module name="SuiteCommerce.Blog.TaxonomyNavigation.View"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.Blog.TaxonomyNavigation.View", ["require", "exports", "Backbone", "sc_blog_taxonomy_navigation.tpl", "SuiteCommerce.Blog.Common", "Backbone.CollectionView", "SuiteCommerce.Blog.DataProvider", "SuiteCommerce.Blog.TaxonomyNavigation.Taxonomy.View", "SuiteCommerce.Blog.TaxonomyNavigation.Configuration", "SuiteCommerce.Blog.TaxonomyNavigation.Taxonomy.Model"], function (require, exports, Backbone_1, taxonomyNavigationViewTemplate, Common_1, BackboneCollectionView, DataProvider_1, TaxonomyNavigation_Taxonomy_View_1, TaxonomyNavigation_Configuration_1, TaxonomyNavigation_Taxonomy_Model_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var TaxonomyNavigationView = /** @class */ (function (_super) {
        __extends(TaxonomyNavigationView, _super);
        function TaxonomyNavigationView(options) {
            var _this = _super.call(this, options) || this;
            _this.template = taxonomyNavigationViewTemplate;
            _this.events = {
                'click [data-action="expand-taxonomy-list"]': 'toggleTaxonomyList',
            };
            _this.navigationData = options.navigationData;
            _this.fetchTaxonomies();
            _this.setupDataProviderListener();
            return _this;
        }
        TaxonomyNavigationView.prototype.setupDataProviderListener = function () {
            var _this = this;
            DataProvider_1.DataProvider.entitiesModel.on('change', function () {
                _this.fetchTaxonomies();
            });
        };
        TaxonomyNavigationView.prototype.fetchTaxonomies = function () {
            this.model.taxonomies.reset();
            this.includePostCategories();
            this.includeDefaultTaxonomies();
            this.highlightSelected();
            this.render();
        };
        TaxonomyNavigationView.prototype.includeDefaultTaxonomies = function () {
            this.model.taxonomies.add(new TaxonomyNavigation_Taxonomy_Model_1.TaxonomyNavigationTaxonomyModel({
                name: Common_1.DefaultTaxonomies.all.name,
                urlComponent: Common_1.AvailableTaxonomies.category + "/" + Common_1.DefaultTaxonomies.all.urlComponent,
            }), { sort: false });
            var featuredTerm = DataProvider_1.DataProvider.terms.getTermByDefaultAlias(Common_1.DefaultTaxonomies.featured.defaultAlias);
            if (DataProvider_1.DataProvider.terms.size() > 0 && featuredTerm && featuredTerm.isUsed) {
                this.model.taxonomies.unshift(new TaxonomyNavigation_Taxonomy_Model_1.TaxonomyNavigationTaxonomyModel({
                    name: featuredTerm.name,
                    urlComponent: Common_1.AvailableTaxonomies.term + "/" + featuredTerm.urlComponent,
                }));
            }
        };
        TaxonomyNavigationView.prototype.includePostCategories = function () {
            var _this = this;
            DataProvider_1.DataProvider.categories.each(function (category) {
                if (category.isUsed) {
                    _this.model.taxonomies.add(new TaxonomyNavigation_Taxonomy_Model_1.TaxonomyNavigationTaxonomyModel({
                        name: category.name,
                        urlComponent: Common_1.AvailableTaxonomies.category + "/" + category.urlComponent,
                    }));
                }
            });
        };
        TaxonomyNavigationView.prototype.highlightSelected = function () {
            var _this = this;
            if (this.navigationData && this.navigationData.taxonomies) {
                this.model.taxonomies.each(function (taxonomy) {
                    _this.navigationData.taxonomies.forEach(function (filter) {
                        if (taxonomy.urlComponent.split('/')[1] === filter.value) {
                            taxonomy.isHighlighted = true;
                        }
                    });
                });
            }
        };
        TaxonomyNavigationView.prototype.getHighlightedTaxonomy = function () {
            return this.model.taxonomies.find(function (taxonomy) { return taxonomy.isHighlighted; });
        };
        TaxonomyNavigationView.prototype.toggleTaxonomyList = function () {
            var chevronIcon = this.$el.find('.sc-blog-post-taxonomy-navigation-list-title-icon');
            var taxonomiesContainer = this.$el.find('.sc-blog-post-taxonomy-navigation-container');
            chevronIcon.toggleClass('transform');
            taxonomiesContainer.toggleClass('expanded');
        };
        Object.defineProperty(TaxonomyNavigationView.prototype, "childViews", {
            get: function () {
                var _this = this;
                return {
                    'Taxonomies.View': function () {
                        return new BackboneCollectionView({
                            childView: TaxonomyNavigation_Taxonomy_View_1.TaxonomyNavigationTaxonomyView,
                            collection: _this.model.taxonomies,
                        });
                    },
                };
            },
            enumerable: true,
            configurable: true
        });
        TaxonomyNavigationView.prototype.getContext = function () {
            var taxonomy = this.getHighlightedTaxonomy();
            return {
                sectionTitle: TaxonomyNavigation_Configuration_1.TaxonomyNavigationConfiguration.taxonomyNavigationTitle,
                activeTaxonomy: taxonomy ? taxonomy.name : '',
            };
        };
        return TaxonomyNavigationView;
    }(Backbone_1.View));
    exports.TaxonomyNavigationView = TaxonomyNavigationView;
});
